export default "__VITE_ASSET__2b73a180__"